import {display} from './display';

export const store = {
    display
};